import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full bg-zinc-50 fixed bottom-0 py-2">
      <div className="container mx-auto flex flex-row items-center justify-center px-5 sm:px-2 md:px-0">
        <p className="text-base sm:text-lg text-black">FT &copy;2023, FinTrack - All Rights Reserved</p>
      </div>
    </footer>
  );
}
